module.exports = __webpack_public_path__ + "static/media/cu_step04.12b7cd27.jpg";